module.exports = __webpack_public_path__ + "img/placeholder.0b618444.svg";